<!--  结费任务修改页面  -->
<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        结费任务修改
        <small>结费任务修改</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 结费任务修改
          </a>
        </li>
        <li class="active">结费任务修改</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div id="atptoolbar"></div>

      <!--  申请表单  -->
      <div class="apply-form">
        <!-- modal-body-->

        <div class="form-group overflow-hidden">
          <label class="control-sidebar-subheading col-sm-4">
            请选择基站
            <select class="form-control" v-model="selectedStationID" @change="chooseStation(selectedStationID)">
              <option v-for="(item,index) in stationList" :key="index" :value="item.stst_atpid">
                {{item.stst_commname}}
              </option>
            </select>
          </label>
        </div>

        <div class="pay-task-list-panel">

          <div v-for="(taskItem,index) in payTaskList" :key="index" class="pay-task-item">
            <!--  信息展示区  -->
            <div class="pay-task-info">
              <div>
                (ID:{{taskItem.id || '新增'}}) 应结费金额 : {{taskItem.money}}
              </div>
              <div class="can_pay_time">
                可结费时间 : {{taskItem.can_pay_time}}
              </div>
              <div class="pay_at">
                实际结费时间 : {{taskItem.pay_at}}
              </div>
              <div class="remark">
                备注 : {{taskItem.remark}}
              </div>
            </div>
            <!--  移除按钮  -->
            <div class="pay-task-right">
              <div class="type">
                <span v-if="taskItem.type == 1">业主租金</span>
                <span v-if="taskItem.type == 2">局方地租金</span>
                <span v-if="taskItem.type == 3">局方杆租金</span>
                <span v-if="taskItem.type == 4">业务协调费</span>
                <span v-if="taskItem.type == 5">平台签约奖励</span>
                <span v-if="taskItem.type == 6">杆塔资源费</span>
                <span v-if="taskItem.type == 7">商务提成</span>
              </div>
              <div class="remove-button">
                <button class="btn btn-warning" type="button" id="sys_remove" @click="pay_task_remove(index)">移除
                </button>
              </div>
            </div>
          </div>

        </div>

        <div class="form-group overflow-hidden">
          <label class="control-sidebar-subheading col-sm-4">
            选择类型
            <select class="form-control" v-model="form.类型">
              <option value="">请选择类型</option>
              <option value="1">业主租金</option>
              <option value="2">局方地租金</option>
              <option value="3">局方杆租金</option>
              <option value="4">业务协调费</option>
              <option value="5">平台签约奖励</option>
              <option value="6">杆塔资源费</option>
              <option value="7">商务提成</option>
            </select>
          </label>

          <label class="control-sidebar-subheading col-sm-4">
            应结费金额(元)
            <input type="number" class="form-control" v-model="form.应结费金额" placeholder="应结费金额"/>
          </label>
          <label class="control-sidebar-subheading col-sm-4">
            备注
            <input type="text" class="form-control" v-model="form.备注" placeholder="备注"/>
          </label>
        </div>

        <div class="form-group overflow-hidden">
          <label class="control-sidebar-subheading col-sm-4">
            可结费时间
            <input
              id="可结费时间"
              name="可结费时间"
              type="text"
              v-model="form.可结费时间"
              class="form-control field"
              @click="datePicker('可结费时间')"
            />
          </label>

          <label class="control-sidebar-subheading col-sm-4">
            实际结费时间(已结清)
            <input
              id="实际结费时间"
              name="实际结费时间"
              type="text"
              v-model="form.实际结费时间"
              class="form-control field"
              @click="datePicker('实际结费时间')"
            />
          </label>

          <label class="col-sm-1"></label>

          <label class="col-sm-2">
            <button type="button" class="btn btn-primary" style="width: 100px;margin: 20px 0;" @click="addInPayTask">
              增加
            </button>
          </label>
        </div>

      </div>
      <!-- modal-footer -->
      <div class="modal-footer">
        <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
        <button type="button" class="btn btn-primary" @click="submit">确定</button>
      </div>

    </section>
  </div>
</template>

<script>

import {datepicker} from 'eonasdan-bootstrap-datetimepicker'

export default {
  name: 'applyPayTaskSetUp',
  data() {
    return {
      stationList: [], // 基站列表
      selectedStationID: null, // 当前选中基站ID
      payTaskList: [], // 结费任务列表
      form: { // 新增的结费任务表单
        '类型': '',
        '应结费金额': '',
        '可结费时间': '',
        '实际结费时间': '',
        '备注': ''
      }
    }
  },

  components: {datepicker},

  mounted: function () {
    let self = this
    let org_id = JSON.parse(localStorage.getItem('companyInfo')).id
    self.org_id = org_id
    console.log('___页面挂载成功,org_id:', org_id)

    // 获取公司下基站列表
    self.global.axiosGet(self, `stations/?org_id=${org_id}&per_page=999999`, function (res) {
      console.log('___获取到基站列表', res)
      self.stationList = res.rows
    })
  },

  methods: {
    chooseStation: function (value) {
      let self = this
      console.log('___切换基站', value, '开始获取基站结费任务')
      self.global.axiosGet(self, `pay_tasks/?station_id=${value}&per_page=999999`, function (res) {
        console.log('___获取到基站结费任务信息', res, '数据', res.rows)
        self.payTaskList = res.rows
      })
    },

    addInPayTask: function () {
      if (!this.form.可结费时间 || !this.form.类型 || !this.form.应结费金额 || !this.form.备注) {
        alert('请将任务填写完全!')
        return
      }

      const newTask = {
        'type': this.form.类型,
        'money': this.form.应结费金额,
        'remark': this.form.备注,
        'can_pay_time': this.form.可结费时间,
        'pay_at': this.form.实际结费时间
      }
      console.log('___添加结费任务', newTask)
      let payTaskList = JSON.parse(JSON.stringify(this.payTaskList));
      payTaskList.push(newTask)
      this.$set(this, 'payTaskList', payTaskList);
    },

    pay_task_remove: function (index) {
      let payTaskList = JSON.parse(JSON.stringify(this.payTaskList));
      payTaskList.splice(index, 1);
      this.$set(this, 'payTaskList', payTaskList);
    },

    submit: function () { // 发起结费任务修改
      let self = this
      let checkPass = true
      if (!self.form.类型 || !self.form.应结费金额 || !self.form.可结费时间)
        checkPass = false
      if (!checkPass) {
        alert('请将申请单填写完毕')
        return
      }

      // 基站信息
      let station = {}
      let stationList = JSON.parse(JSON.stringify(this.stationList))
      stationList.map(item => {
        if (item.stst_atpid === self.selectedStationID)
          station = item
      })

      const formData = {
        '公司ID': this.org_id,
        '备注': station.stst_commname,
        'station': station,
        'payTaskList': self.payTaskList,
        'selectedStationID': self.selectedStationID
      }

      self.global.axiosPost(self,
        'apply/7/',
        formData,
        function (res) {
          console.log('___resp', res)
          if (res.status === 'success') {
            alert('提交成功')
          }
        },
        function (response) {
          console.log('___提交失败')
          response.response && response.response.data.message && alert(response.response.data.message)
        }
      )

    },

    datePicker: function (elementId) {
      let self = this
      WdatePicker({
        el: elementId,
        dateFmt: 'yyyy-MM-dd HH:mm:ss', //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $('#' + elementId).val()
          console.log('___日期elementId', elementId, value)
          // var timeStamp = self.global.timeToStamp(value)
          self.form[elementId] = value
        },
        oncleared: function () {
          self[elementId] = null
        },
        isShowClear: true,
        readOnly: true
      })
    }

  }

}
</script>

<style scoped>

  .overflow-hidden {
    overflow: hidden
  }

  .pay-task-list-panel {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .pay-task-item {
    width: 60%;
    height: 100px;
    margin: 10px auto 0 auto;
    border-radius: 10px;
    background-color: #C4C4C4;
    display: flex;
  }

  .pay-task-info {
    width: 60%;
    font-size: 18px;
    padding: 5px 0 0 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    text-align: left;
  }

  .pay-task-info .can_pay_time, .pay_at {
    font-size: 15px;
  }

  .pay-task-info .remark {
    font-size: 15px;
    color: gray;
  }

  .pay-task-right {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 40%;
    padding: 5px 0 0 0;
    text-align: right;
  }

  .pay-task-right .type {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyPayTaskSetUp.vue